import { api } from "@/builders/axios";
import {
  EnrolledCourseData,
  EnrolledCourseList,
} from "@/builders/types/course-enrollment";
import { FilterParams } from "@/builders/types/filter-params";

export const id = async (courseId: number) => {
  return api
    .get<EnrolledCourseData>(`/course-enrollments/${courseId}`)
    .then(({ data }) => data);
};

export const create = async (courseId: number) => {
  return api.post(`/course-enrollments/${courseId}`);
};

const rate = async (variables: {
  courseId: number;
  data: {
    rating: string;
    feedback: string;
  };
}) => {
  const { courseId, data } = variables;
  return api.post(`/course-enrollments/${courseId}/rate`, data);
};
export const remove = async (courseId: number) => {
  return api.delete(`/course-enrollments/${courseId}`);
};

export const update = async (courseId: number, data: any) => {
  return api.put(`/course-enrollments/${courseId}`, data);
};

export const list = async (
  params?: FilterParams<{
    status?: "ongoing" | "completed";
    is_favourite?: "True" | "False";
  }>
) => {
  return api
    .get<EnrolledCourseList>(`/course-enrollments`, { params })
    .then(({ data }) => data);
};
export const single_enrollment = async (
  id: number,
  params?: FilterParams<{
    status?: "ongoing" | "completed";
    is_favourite?: "True" | "False";
  }>
) => {
  return api
    .get<EnrolledCourseData>(`/course-enrollments/${id}`, { params })
    .then(({ data }) => data);
};

export const add_remove_favorite = async (enrollment_id?: number) => {
  return api
    .post<{
      is_favourite: true;
    }>(`/course-enrollments/${enrollment_id}/add-remove-favourite`, {
      is_favourite: true,
    })
    .then(({ data }) => data);
};

export const mark_content_as_completed = async (variables: {
  enrolled_course_id: number;
  content_ids: number[];
}) => {
  const { enrolled_course_id, content_ids } = variables;

  return api
    .post(
      `/course-enrollments/${enrolled_course_id}/mark-content-as-completed`,
      { content_ids }
    )
    .then(({ data }) => data);
};

export const course_enrollment = {
  list,
  id,
  create,
  remove,
  update,
  add_remove_favorite,
  mark_content_as_completed,
  rate,
  single_enrollment,
};
